module.exports = __webpack_public_path__ + "static/media/gorra (7).bc659c07.png";